import * as React from 'react'
import Image from 'next/image'
import van from '/public/img/nubrakes-van-house-small@3x.jpg'
export const ImageSection = () => {
  return (
    <section className={'d-block d-md-none my-0 py-0'}>
      <Image src={van} alt="NuBrakes Feature Image" layout="responsive" />
    </section>
  )
}

export default ImageSection
